/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DishPortionDto } from '../models';
// @ts-ignore
import type { DishPortionIdDto } from '../models';
// @ts-ignore
import type { DishPortionPropertiesDto } from '../models';
// @ts-ignore
import type { DishPortionSearchQueryDto } from '../models';
// @ts-ignore
import type { DishesPortionSearchResponseDto } from '../models';
// @ts-ignore
import type { ExtendDishPortionsRequestDto } from '../models';
// @ts-ignore
import type { ExtendDishPortionsResponseDto } from '../models';
// @ts-ignore
import type { UpdateDishPortionRequestDto } from '../models';
/**
 * RestDishPortionApi - axios parameter creator
 */
export const RestDishPortionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add dish portion
         * @param {number} dishId 
         * @param {DishPortionPropertiesDto} dishPortionPropertiesDto Add dish portion request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDishPortion: async (dishId: number, dishPortionPropertiesDto: DishPortionPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dishId' is not null or undefined
            assertParamExists('addDishPortion', 'dishId', dishId)
            // verify required parameter 'dishPortionPropertiesDto' is not null or undefined
            assertParamExists('addDishPortion', 'dishPortionPropertiesDto', dishPortionPropertiesDto)
            const localVarPath = `/api/dishes/{dishId}/portions`
                .replace('{dishId}', encodeURIComponent(String(dishId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dishPortionPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zbiorczo wystawia cenniki na kolejny okres dla wskazanych dań. Pozycje walidowane są niezależnie, więc odpowiedź mówi per danie, czy cennik powstał, czy odpadł na walidacji (okres w przeszłości, poza sezonowością albo nachodzący na istniejący cennik). 
         * @summary Extend dish price lists into the next period
         * @param {ExtendDishPortionsRequestDto} extendDishPortionsRequestDto Bulk extend dish price lists request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendDishPortions: async (extendDishPortionsRequestDto: ExtendDishPortionsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extendDishPortionsRequestDto' is not null or undefined
            assertParamExists('extendDishPortions', 'extendDishPortionsRequestDto', extendDishPortionsRequestDto)
            const localVarPath = `/api/dishes/portions/extend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extendDishPortionsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get dish portion
         * @param {number} dishId 
         * @param {number} dishPortionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDishPortion: async (dishId: number, dishPortionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dishId' is not null or undefined
            assertParamExists('getDishPortion', 'dishId', dishId)
            // verify required parameter 'dishPortionId' is not null or undefined
            assertParamExists('getDishPortion', 'dishPortionId', dishPortionId)
            const localVarPath = `/api/dishes/{dishId}/portions/{dishPortionId}`
                .replace('{dishId}', encodeURIComponent(String(dishId)))
                .replace('{dishPortionId}', encodeURIComponent(String(dishPortionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for dishes portions
         * @param {number} page 
         * @param {number} pageSize 
         * @param {number} dishId 
         * @param {DishPortionSearchQueryDto} dishPortionSearchQueryDto Dish portion search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDishesPortions: async (page: number, pageSize: number, dishId: number, dishPortionSearchQueryDto: DishPortionSearchQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchDishesPortions', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchDishesPortions', 'pageSize', pageSize)
            // verify required parameter 'dishId' is not null or undefined
            assertParamExists('searchDishesPortions', 'dishId', dishId)
            // verify required parameter 'dishPortionSearchQueryDto' is not null or undefined
            assertParamExists('searchDishesPortions', 'dishPortionSearchQueryDto', dishPortionSearchQueryDto)
            const localVarPath = `/api/dishes/{dishId}/portions/search`
                .replace('{dishId}', encodeURIComponent(String(dishId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dishPortionSearchQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update dish portion
         * @param {number} dishId 
         * @param {number} dishPortionId 
         * @param {UpdateDishPortionRequestDto} updateDishPortionRequestDto Update dish portion request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDishPortion: async (dishId: number, dishPortionId: number, updateDishPortionRequestDto: UpdateDishPortionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dishId' is not null or undefined
            assertParamExists('updateDishPortion', 'dishId', dishId)
            // verify required parameter 'dishPortionId' is not null or undefined
            assertParamExists('updateDishPortion', 'dishPortionId', dishPortionId)
            // verify required parameter 'updateDishPortionRequestDto' is not null or undefined
            assertParamExists('updateDishPortion', 'updateDishPortionRequestDto', updateDishPortionRequestDto)
            const localVarPath = `/api/dishes/{dishId}/portions/{dishPortionId}`
                .replace('{dishId}', encodeURIComponent(String(dishId)))
                .replace('{dishPortionId}', encodeURIComponent(String(dishPortionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDishPortionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestDishPortionApi - functional programming interface
 */
export const RestDishPortionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestDishPortionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add dish portion
         * @param {number} dishId 
         * @param {DishPortionPropertiesDto} dishPortionPropertiesDto Add dish portion request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDishPortion(dishId: number, dishPortionPropertiesDto: DishPortionPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DishPortionIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDishPortion(dishId, dishPortionPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDishPortionApi.addDishPortion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zbiorczo wystawia cenniki na kolejny okres dla wskazanych dań. Pozycje walidowane są niezależnie, więc odpowiedź mówi per danie, czy cennik powstał, czy odpadł na walidacji (okres w przeszłości, poza sezonowością albo nachodzący na istniejący cennik). 
         * @summary Extend dish price lists into the next period
         * @param {ExtendDishPortionsRequestDto} extendDishPortionsRequestDto Bulk extend dish price lists request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extendDishPortions(extendDishPortionsRequestDto: ExtendDishPortionsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendDishPortionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extendDishPortions(extendDishPortionsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDishPortionApi.extendDishPortions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get dish portion
         * @param {number} dishId 
         * @param {number} dishPortionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDishPortion(dishId: number, dishPortionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DishPortionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDishPortion(dishId, dishPortionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDishPortionApi.getDishPortion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search for dishes portions
         * @param {number} page 
         * @param {number} pageSize 
         * @param {number} dishId 
         * @param {DishPortionSearchQueryDto} dishPortionSearchQueryDto Dish portion search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDishesPortions(page: number, pageSize: number, dishId: number, dishPortionSearchQueryDto: DishPortionSearchQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DishesPortionSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDishesPortions(page, pageSize, dishId, dishPortionSearchQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDishPortionApi.searchDishesPortions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update dish portion
         * @param {number} dishId 
         * @param {number} dishPortionId 
         * @param {UpdateDishPortionRequestDto} updateDishPortionRequestDto Update dish portion request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDishPortion(dishId: number, dishPortionId: number, updateDishPortionRequestDto: UpdateDishPortionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDishPortion(dishId, dishPortionId, updateDishPortionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDishPortionApi.updateDishPortion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestDishPortionApi - factory interface
 */
export const RestDishPortionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestDishPortionApiFp(configuration)
    return {
        /**
         * 
         * @summary Add dish portion
         * @param {number} dishId 
         * @param {DishPortionPropertiesDto} dishPortionPropertiesDto Add dish portion request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDishPortion(dishId: number, dishPortionPropertiesDto: DishPortionPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<DishPortionIdDto> {
            return localVarFp.addDishPortion(dishId, dishPortionPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Zbiorczo wystawia cenniki na kolejny okres dla wskazanych dań. Pozycje walidowane są niezależnie, więc odpowiedź mówi per danie, czy cennik powstał, czy odpadł na walidacji (okres w przeszłości, poza sezonowością albo nachodzący na istniejący cennik). 
         * @summary Extend dish price lists into the next period
         * @param {ExtendDishPortionsRequestDto} extendDishPortionsRequestDto Bulk extend dish price lists request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendDishPortions(extendDishPortionsRequestDto: ExtendDishPortionsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExtendDishPortionsResponseDto> {
            return localVarFp.extendDishPortions(extendDishPortionsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get dish portion
         * @param {number} dishId 
         * @param {number} dishPortionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDishPortion(dishId: number, dishPortionId: number, options?: RawAxiosRequestConfig): AxiosPromise<DishPortionDto> {
            return localVarFp.getDishPortion(dishId, dishPortionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search for dishes portions
         * @param {number} page 
         * @param {number} pageSize 
         * @param {number} dishId 
         * @param {DishPortionSearchQueryDto} dishPortionSearchQueryDto Dish portion search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDishesPortions(page: number, pageSize: number, dishId: number, dishPortionSearchQueryDto: DishPortionSearchQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<DishesPortionSearchResponseDto> {
            return localVarFp.searchDishesPortions(page, pageSize, dishId, dishPortionSearchQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update dish portion
         * @param {number} dishId 
         * @param {number} dishPortionId 
         * @param {UpdateDishPortionRequestDto} updateDishPortionRequestDto Update dish portion request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDishPortion(dishId: number, dishPortionId: number, updateDishPortionRequestDto: UpdateDishPortionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDishPortion(dishId, dishPortionId, updateDishPortionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestDishPortionApi - interface
 */
export interface RestDishPortionApiInterface {
    /**
     * 
     * @summary Add dish portion
     * @param {number} dishId 
     * @param {DishPortionPropertiesDto} dishPortionPropertiesDto Add dish portion request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addDishPortion(dishId: number, dishPortionPropertiesDto: DishPortionPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<DishPortionIdDto>;

    /**
     * Zbiorczo wystawia cenniki na kolejny okres dla wskazanych dań. Pozycje walidowane są niezależnie, więc odpowiedź mówi per danie, czy cennik powstał, czy odpadł na walidacji (okres w przeszłości, poza sezonowością albo nachodzący na istniejący cennik). 
     * @summary Extend dish price lists into the next period
     * @param {ExtendDishPortionsRequestDto} extendDishPortionsRequestDto Bulk extend dish price lists request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    extendDishPortions(extendDishPortionsRequestDto: ExtendDishPortionsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExtendDishPortionsResponseDto>;

    /**
     * 
     * @summary Get dish portion
     * @param {number} dishId 
     * @param {number} dishPortionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDishPortion(dishId: number, dishPortionId: number, options?: RawAxiosRequestConfig): AxiosPromise<DishPortionDto>;

    /**
     * 
     * @summary Search for dishes portions
     * @param {number} page 
     * @param {number} pageSize 
     * @param {number} dishId 
     * @param {DishPortionSearchQueryDto} dishPortionSearchQueryDto Dish portion search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchDishesPortions(page: number, pageSize: number, dishId: number, dishPortionSearchQueryDto: DishPortionSearchQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<DishesPortionSearchResponseDto>;

    /**
     * 
     * @summary Update dish portion
     * @param {number} dishId 
     * @param {number} dishPortionId 
     * @param {UpdateDishPortionRequestDto} updateDishPortionRequestDto Update dish portion request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDishPortion(dishId: number, dishPortionId: number, updateDishPortionRequestDto: UpdateDishPortionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestDishPortionApi - object-oriented interface
 */
export class RestDishPortionApi extends BaseAPI implements RestDishPortionApiInterface {
    /**
     * 
     * @summary Add dish portion
     * @param {number} dishId 
     * @param {DishPortionPropertiesDto} dishPortionPropertiesDto Add dish portion request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addDishPortion(dishId: number, dishPortionPropertiesDto: DishPortionPropertiesDto, options?: RawAxiosRequestConfig) {
        return RestDishPortionApiFp(this.configuration).addDishPortion(dishId, dishPortionPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zbiorczo wystawia cenniki na kolejny okres dla wskazanych dań. Pozycje walidowane są niezależnie, więc odpowiedź mówi per danie, czy cennik powstał, czy odpadł na walidacji (okres w przeszłości, poza sezonowością albo nachodzący na istniejący cennik). 
     * @summary Extend dish price lists into the next period
     * @param {ExtendDishPortionsRequestDto} extendDishPortionsRequestDto Bulk extend dish price lists request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public extendDishPortions(extendDishPortionsRequestDto: ExtendDishPortionsRequestDto, options?: RawAxiosRequestConfig) {
        return RestDishPortionApiFp(this.configuration).extendDishPortions(extendDishPortionsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get dish portion
     * @param {number} dishId 
     * @param {number} dishPortionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDishPortion(dishId: number, dishPortionId: number, options?: RawAxiosRequestConfig) {
        return RestDishPortionApiFp(this.configuration).getDishPortion(dishId, dishPortionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search for dishes portions
     * @param {number} page 
     * @param {number} pageSize 
     * @param {number} dishId 
     * @param {DishPortionSearchQueryDto} dishPortionSearchQueryDto Dish portion search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchDishesPortions(page: number, pageSize: number, dishId: number, dishPortionSearchQueryDto: DishPortionSearchQueryDto, options?: RawAxiosRequestConfig) {
        return RestDishPortionApiFp(this.configuration).searchDishesPortions(page, pageSize, dishId, dishPortionSearchQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update dish portion
     * @param {number} dishId 
     * @param {number} dishPortionId 
     * @param {UpdateDishPortionRequestDto} updateDishPortionRequestDto Update dish portion request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDishPortion(dishId: number, dishPortionId: number, updateDishPortionRequestDto: UpdateDishPortionRequestDto, options?: RawAxiosRequestConfig) {
        return RestDishPortionApiFp(this.configuration).updateDishPortion(dishId, dishPortionId, updateDishPortionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

